export default __webpack_public_path__ + "static/media/small.a8d6a139.jpg";